var kind = require("enyo/kind");

require("app/ui/Message.less");

module.exports = kind(/** @lends  app.ui.Message.prototype */ {

    /**
     * @private
     */
    name: "app.ui.Message",

    /**
     * @private
     */
    classes: "app-ui-message",

    /**
     * @private
     */
    components: [{
        name:       "content",
        classes:    "app-ui-message__content",
        components: [{
            name:    "title",
            classes: "app-ui-message__title",
            tag:     "h2"
        }, {
            name:    "body",
            classes: "app-ui-message__body",
            tag:     "p"
        }]
    }]

});
